import React from 'react';
const DropdownLocal = ({
  id,
  label,
  name,
  options,
  placeholder,
  value,
  handleChange,
  errorText,
  isDisabled = false,
}) => (
  <div className='custom-dropdown'>
    <label htmlFor={id}>{label}</label>
    <select
      id={id}
      name={name}
      value={value}
      onChange={handleChange}
      disabled={isDisabled}
    >
      <option value=''>{placeholder}</option>
      {options &&
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </select>
    {errorText && <span className='error'>{errorText}</span>}
  </div>
);
export default DropdownLocal;
